module.exports = __webpack_public_path__ + "static/media/rose3.0006a8a9.jpeg";